import { ChemicalOrderItemBM } from '../../types/BusinessModel/TankCleaning/ChemicalOrderItemBM';
import { ChemicalOrderItem } from '../../types/ViewModel/TankCleaning/Order/ChemicalOrderItem';

export const createChemicalOrderItem = (chemicalOrderItem: ChemicalOrderItemBM): ChemicalOrderItem => {
    return {
        chemicalOrderItemId: chemicalOrderItem.chemicalOrderItemId,
        chemicalOrderId: chemicalOrderItem.chemicalOrderId,
        chemical: null,
        chemicalId: chemicalOrderItem.chemicalId,
        orderValue: chemicalOrderItem.orderValue,
        robValue: chemicalOrderItem.robValue,
        comment: chemicalOrderItem.comment,
    };
};

export const createChemicalOrderItemList = (chemicalOrderItemList: ChemicalOrderItemBM[]) =>
    chemicalOrderItemList?.map((chemicalOrder) => createChemicalOrderItem(chemicalOrder));

export const createChemicalOrderItemBM = (chemicalOrderItem: ChemicalOrderItem): ChemicalOrderItemBM => {
    return {
        chemicalOrderItemId: chemicalOrderItem.chemicalOrderItemId,
        chemicalOrderId: chemicalOrderItem.chemicalOrderId,
        chemicalId: chemicalOrderItem.chemicalId,
        orderValue: chemicalOrderItem.orderValue,
        robValue: chemicalOrderItem.robValue,
        comment: chemicalOrderItem.comment,
    };
};

export const createChemicalOrderItemListBM = (chemicalOrderItems: ChemicalOrderItemBM[]) =>
    chemicalOrderItems.map((chemicalOrderItem) => createChemicalOrderItemBM(chemicalOrderItem));
